import React, {useEffect, useState} from 'react';
import ReactLeafLetMapComponent from '../CommonComponent/MapComponents/ReactLeafLetMapComponent';
import {Circle, Marker, Polyline, Popup, useMap} from 'react-leaflet';
import {LatLngTuple} from 'leaflet';
import TruckMarkerIcon from '../../assets/images/ajex_vehicle.png';
import L from 'leaflet';

import { Descriptions } from 'antd';

// const RoutePolyline = ({start, end}) => {
//   const [routeCoordinates, setRouteCoordinates] = useState<
//     LatLngTuple[] | null
//   >(null);
//   const [loading, setLoading] = useState<boolean>(true);

//   useEffect(() => {
//     const fetchRoute = async () => {
//       try {
//         setLoading(true);
//         const url = `https://router.project-osrm.org/route/v1/driving/${start[1]},${start[0]};${end[1]},${end[0]}?overview=full&geometries=geojson`;

//         const response = await fetch(url);
//         const data = await response.json();

//         if (data.code === 'Ok' && data.routes && data.routes.length > 0) {
//           const coordinates = data.routes[0].geometry.coordinates.map(
//             (coord) => [coord[1], coord[0]]
//           );
//           setRouteCoordinates(coordinates);
//         }
//       } catch (error) {
//         console.error('Error fetching route:', error);
//         setRouteCoordinates([start, end]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRoute();
//   }, [start, end]);

//   if (loading || !routeCoordinates) {
//     return null;
//   }

//   return (
//     <Polyline
//       positions={routeCoordinates}
//       pathOptions={{
//         color: 'red',
//         weight: 4,
//         opacity: 0.8
//       }}
//     />
//   );
// };

const ajexMarkerIcon = L.icon({
  iconUrl: TruckMarkerIcon,
  iconSize: [30, 30],
  iconAnchor: [25, 10],
  popupAnchor: [0, -12.5]
});

const MapController = ({center}) => {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 10);
  }, [map]);

  useEffect(() => {
    if (center) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);

  return null;
};
export const isValidLatLng = (
  latitude?: number | null,
  longitude?: number | null
): boolean => {
  return (
    latitude !== null &&
    longitude !== null &&
    latitude !== undefined &&
    longitude !== undefined &&
    (typeof latitude === 'number' || latitude === '') &&
    (typeof longitude === 'number' || longitude === '') &&
    !Number.isNaN(latitude) &&
    !Number.isNaN(longitude)
  );
};
const NotificationMapComponent = ({ MarkerItem }) => {
  const MarkerPositionIDLE: LatLngTuple = [
    Number(MarkerItem?.previousLatitude),
    Number(MarkerItem?.previousLongitude)
  ];
  const MarkerPositionCurrent: LatLngTuple = [
    Number(MarkerItem?.latitude),
    Number(MarkerItem?.longitude)
  ]

   const shouldShowPolyline =
     MarkerItem?.notificationType === 'MOVING' &&
     isValidLatLng(
       Number(MarkerItem?.previousLatitude),
       Number(MarkerItem?.previousLongitude)
     ) &&
    isValidLatLng(Number(MarkerItem?.latitude), Number(MarkerItem?.longitude));
  
  const center:LatLngTuple = isValidLatLng(Number(MarkerItem?.previousLatitude), Number(MarkerItem?.previousLongitude)) ? MarkerPositionIDLE : isValidLatLng(Number(MarkerItem?.latitude), Number(MarkerItem?.longitude)) ? MarkerPositionCurrent : [24,45]

  return (
    <>
      <ReactLeafLetMapComponent
        zoom={15}
        center={center}
        key={MarkerItem?.id}
      >
       <MapController
          center={center}
        />

        {shouldShowPolyline && (
          <Polyline
            positions={[MarkerPositionIDLE, MarkerPositionCurrent]}
            pathOptions={{
              color: '#2196F3',
              weight: 3,
              opacity: 0.8,
              dashArray: '10, 10'
            }}
          />
        )}
        {/* {shouldShowPolyline && (
          <RoutePolyline
            start={MarkerPositionIDLE}
            end={MarkerPositionCurrent}
          />
        )} */}

        {/* Previous Location => IDLE */}
        {isValidLatLng(
          Number(MarkerItem?.previousLatitude),
          Number(MarkerItem?.previousLongitude)
        ) && (
          <Circle
            center={MarkerPositionIDLE}
            key={MarkerItem?.id}
            radius={100}
            pathOptions={{
              color: '#ff0000',
              fillColor: '#ff0000',
              fillOpacity: 0.2,
              weight: 2
            }}
          >
            <Marker
              key={MarkerItem?.id}
              position={MarkerPositionIDLE}
              icon={ajexMarkerIcon}
            >
              <Popup key={MarkerItem?.id}>
                <Descriptions column={1} size="small">
                  <Descriptions.Item label="Plate Number">
                    {' '}
                    <strong>{MarkerItem?.vehiclePlateNumber}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="Driver">
                    {MarkerItem?.driverName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Status">
                    {MarkerItem?.status}
                  </Descriptions.Item>
                  <Descriptions.Item label="Message">
                    {MarkerItem?.message}
                  </Descriptions.Item>
                </Descriptions>
              </Popup>
            </Marker>
          </Circle>
        )}
        {/* MOVING POSITION */}
        {isValidLatLng(
          Number(MarkerItem?.latitude),
          Number(MarkerItem?.longitude)
        ) &&
          MarkerItem?.notificationType === 'MOVING' && (
            <Circle
              center={MarkerPositionCurrent}
              key={MarkerItem?.id}
              radius={20}
              pathOptions={{
                color: '#03fc35',
                fillColor: '#03fc35',
                fillOpacity: 0.2,
                weight: 2
              }}
            >
              <Marker
                key={MarkerItem?.id}
                position={MarkerPositionCurrent}
                icon={ajexMarkerIcon}
              >
                <Popup key={MarkerItem?.id}>
                  <Descriptions column={1} size="small">
                    <Descriptions.Item label="Plate Number">
                      {' '}
                      <strong>{MarkerItem?.vehiclePlateNumber}</strong>
                    </Descriptions.Item>
                    <Descriptions.Item label="Driver">
                      {MarkerItem?.driverName}
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                      {MarkerItem?.status}
                    </Descriptions.Item>
                    <Descriptions.Item label="Message">
                      {MarkerItem?.message}
                    </Descriptions.Item>
                  </Descriptions>
                </Popup>
              </Marker>
            </Circle>
          )}
      </ReactLeafLetMapComponent>
    </>
  );
};

export default NotificationMapComponent;
